/* CRB gift guard — Sturzfest
 *
 * The Gel-Sitzkissen offer drops its free items into the cart as their own €0,00 lines
 * (2nd cushion / UV covers / e-book) so the customer can see what the set contains.
 * Without this guard a customer could delete the paid cushion and check out with the
 * free lines alone. Every gift line carries `_crb_gift`; the paid line carries
 * `_crb_set` without `_crb_gift`. No paid line left → drop the gifts.
 *
 * Deliberately defensive: it always calls the original fetch through, never blocks a
 * request, and swallows every error. If it breaks it must break silently.
 */
(function () {
  if (window.__crbGiftGuard) return;
  window.__crbGiftGuard = true;

  var busy = false;

  function isGift(it) {
    return !!(it && it.properties && String(it.properties._crb_gift) === '1');
  }
  function isPaidParent(it) {
    return !!(it && it.properties && it.properties._crb_set && !isGift(it));
  }

  function check() {
    if (busy) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var gifts = cart.items.filter(isGift);
        var parents = cart.items.filter(isPaidParent);
        if (!gifts.length || parents.length) return;   // nothing orphaned

        busy = true;
        var updates = {};
        gifts.forEach(function (it) { updates[it.key] = 0; });
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates }),
        }).then(function () {
          busy = false;
          window.location.reload();
        });
      })
      .catch(function () { busy = false; });
  }

  /* re-check after anything the theme does to the cart */
  var orig = window.fetch;
  if (typeof orig === 'function') {
    window.fetch = function () {
      var p = orig.apply(this, arguments);
      try {
        var a = arguments[0];
        var url = typeof a === 'string' ? a : (a && a.url) || '';
        if (/\/cart\/(change|update|clear)/.test(url)) {
          p.then(function () { setTimeout(check, 400); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  /* Only sweep on load for the cart page itself. Doing it on every page view would add a
     /cart.js request to every session store-wide, which is both wasteful and enough traffic
     to trip Shopify's own request throttling. Line removals anywhere else — including in the
     drawer — go through /cart/change, which the wrapper above already catches. */
  if (/^\/cart(\/|$|\?)/.test(window.location.pathname)) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setTimeout(check, 900); });
    } else {
      setTimeout(check, 900);
    }
  }
})();
